@if (!loadingFaxes) {
  <div>
    @if (outboundFaxes.length > 0) {
      <div>
        @if (prescriber) {
          <p class="phi">
            Displaying faxes for capture patient and prescriber.
            <a target="_blank" routerLink="/capture-admin/patients/{{ patient.id }}/communications">
              View all faxes
            </a>
            for patient {{ patient.fullName }} ({{ patient.dob | date: 'M/d/yyyy' }})
          </p>
        }
        <app-pagination-header [paging]="paging" [label]="'outbound faxes'" (pageSizeChange)="onPageSizeChange($event)" />
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
        <table class="table table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th>CREATED AT</th>
              <th>FAX SENT AT</th>
              <th>PRESCRIBER</th>
              <th>SPECIALTY</th>
              <th>OFFICE</th>
              <th>FAX NUMBER</th>
              <th class="text-center">OUTBOUND STATUS</th>
              <th>CUSTOM TEXT</th>
              <th>CONSULT RECEIVED?</th>
              <th>CALL RECEIVED?</th>
              <th>PROVIDER FAX STATUS</th>
              <th>FAX TYPE</th>
              <th>SENT BY</th>
            </tr>
          </thead>
          <tbody>
            @for (outboundFax of outboundFaxes; track trackItemsBy($index, outboundFax)) {
              <tr>
                <td>{{ outboundFax.createdAt | date: 'M/d/yyyy' }}</td>
                <td>{{ outboundFax.sentAt | date: 'M/d/yyyy' }}</td>
                <td><app-prescriber-name [provider]="outboundFax.provider" /></td>
                <td>{{ outboundFax.provider.displaySpecialty }}</td>
                <td>{{ outboundFax.prescriberOfficesNames && outboundFax.prescriberOfficesNames.join(', ') }}</td>
                <td>
                  <app-phone-number [number]="outboundFax.fax" />
                  <app-copy-to-clipboard [text]="outboundFax.fax | phoneNumber" />
                  @if (outboundFax.office) {
                    <a
                      target="_blank"
                      href="/capture-admin/offices/{{ outboundFax.office.id }}"
                      >
                      <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
                    </a>
                  }
                </td>
                <td class="text-center">
                  <div>
                    @switch (outboundFax.status) {
                      @case (outboundFaxStatuses.queued) {
                        <span> Sending... </span>
                      }
                      @case (outboundFaxStatuses.pendingScheduling) {
                        <span> Pending Scheduling </span>
                      }
                      @case (outboundFaxStatuses.failed) {
                        <span>
                          <div>Failed</div>
                          @if (outboundFax.mostRecentFailureMessage) {
                            <div>{{ outboundFax.mostRecentFailureMessage }}</div>
                          }
                        </span>
                      }
                      @case (outboundFaxStatuses.skipped) {
                        <span>
                          <div>Skipped</div>
                          @if (outboundFax.skipMessage) {
                            <div>Reason: {{ outboundFax.skipMessage }}</div>
                          }
                        </span>
                      }
                      @case (outboundFaxStatuses.scheduled) {
                        <span>
                          <div>Scheduled to send after {{ outboundFax.scheduledTime | date: 'M/dd h:mm a' }}</div>
                          @if (outboundFax.attemptCount > 0) {
                            <div>
                              {{ outboundFax.attemptCount }} failed send attempt{{ outboundFax.attemptCount > 1 ? 's' : '' }}
                            </div>
                          }
                        </span>
                      }
                      @case (outboundFaxStatuses.canceled) {
                        <span>
                          <div>Canceled</div>
                          @if (outboundFax.canceledByUser) {
                            <small>
                              user: {{ outboundFax.canceledByUser.username }}
                            </small>
                          }
                        </span>
                      }
                      @default {
                        <span> {{ outboundFax.status | titlecase }} </span>
                      }
                    }
                  </div>
                  <app-outbound-fax-template [outboundFax]="outboundFax" />
                  @if (outboundFax.status === outboundFaxStatuses.scheduled) {
                    <div class="mt-1 px-1">
                      <a href="" (click)="cancel($event, outboundFax)" class="text-danger">Cancel Fax</a>
                    </div>
                  }
                </td>
                <td class="phi">{{ outboundFax.customNote }}</td>
                <td><app-consult-note-received [outboundFax]="outboundFax" />
                  <td><app-inbound-call-received [outboundFax]="outboundFax" />
                    <td>{{ keyedProviderOfficeStatusOptions[outboundFax.providerOfficeStatus]?.display }}</td>
                    <td>{{ outboundFax.faxType }}</td>
                    <td>{{ outboundFax.sentBy }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <p class="phi">We haven't sent any faxes for {{ patient.fullName }}.</p>
        }
      </div>
    } @else {
      <mat-spinner diameter="30" />
    }
